import { Injectable, Input } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  public is_lskey_display = 0;
  public languageText: any =
    {
      "channel": {
        "key1": " No record found",
        "key2": "Subscribe",
        "key3": "I have read all",
        "key4": "Terms and Conditions",
        "key5": "About Channel",
        "key6": "This is restricted content",
      },
      "clinical": {
        "key1": "No record found",
        "key2": "Oops, something went wrong",
        "key3": "Go to docquity.com",
        "key4": "Like",
        "key5": "Bookmark",
        "key6": "Share",
        "key7": "This is restricted content",
        "key8": "Continue reading",
      },
      "cme": {
        "key1": "No record found",
        "key2": "This is restricted content",
        "key3": "Bookmark",
        "key4": "Attempt Now",
        "key5": "Share",
      },
      "doctalk": {
        "key1": "No record found",
        "key2": "Minutes",
        "key3": "Views",
        "key4": "This is restricted content",
        "key5": "Speaker Details",
        "key6": "Play Now",
        "key7": "Like",
        "key8": "Bookmark",
        "key9": "Share"
      },
      "event": {
        "key1": "No record found",
        "key2": "Days ago",
        "key3": "Share",
        "key4": "Mark Going",
        "key5": "Sessions",
        "key6": "About Events",
        "key7": "Media",
        "key8": "This is restricted content",
      },
      "feed": {
        "key1": "No record found",
        "key2": "More",
        "key3": "Likes",
        "key4": "comment",
        "key5": "Like",
        "key6": "Bookmark",
        "key7": "Share",
        "key8": "Reply",
        "key9": "This is restricted content",
        "key10": "Add a comment"
      },
      "pharma": {
        "key1": "No record found",
        "key2": "About Pharma"
      },
      "session": {
        "key1": "No record found",
        "key2": "Share",
        "key3": "About",
      },
      "survey": {
        "key1": "No record found",
        "key2": "Get more survey",
      },
      "webinar": {
        "key1": "No record found",
        "key2": "Click here to login and watch/read.",
        "key3": "Speaker Details",
        "key4": "Share",
      },
      "common": {
        "key1": "Docquity - Medical Cases",
        "key2": "Discussion App",
        "key3": "Install App",
        "key4": "Something Went Wrong!!!",
      },
      "profile": {
        "key1": "Locked",
        "key2": "About",
        "key3": "Education",
        "key4": "Professional Experience",
        "key5": "Professional Certificate",
        "key6": "Publications",
        "key7": "Sign up/Login to View Complete Profile",
        "key8": "No record found"
      },
      "meeting": {
        "key1": "No record found",
        "key2": "This is a restricted content. Please click to continue login to access the content."
      }
    }

  docquityEventText = {

  }

  cleaverTapText = {}

  branchText = {}




  constructor() { }

}
